import React from 'react'
import { useIntl } from 'gatsby-plugin-react-intl'
import { StaticImage } from 'gatsby-plugin-image'
import * as styles from './Play.module.scss'
import ActivityCarousel from './ActivityCarousel'
import SectionHead from '../section-head/SectionHead'
import Activity from '../activity/Activity'

const Play: React.FC = () => {
  const t = useIntl()

  return (
    <div className={styles.container}>

      <SectionHead
        title={t.formatMessage({ id: 'play.title' })}
        text={(
          <>
            {t.formatMessage({ id: 'play.subtitle1' })}
            <br />
            {t.formatMessage({ id: 'play.subtitle2' })}
          </>
        )}
      />
      <div className={styles.activities}>
        <Activity
          image={(
            <StaticImage
              width={297} height={216}
              src='./assets/activity-1.png' alt=''
            />
        )}
          caption={t.formatMessage({ id: 'play.activity1' })}
        />
        <Activity
          image={(
            <StaticImage
              width={297} height={216}
              src='./assets/activity-2.png' alt=''
            />
        )}
          caption={t.formatMessage({ id: 'play.activity2' })}
        />
        <Activity
          image={(
            <StaticImage
              width={297} height={216}
              src='./assets/activity-3.png' alt=''
            />
        )}
          caption={t.formatMessage({ id: 'play.activity3' })}
        />
        <Activity
          image={(
            <StaticImage
              width={297} height={216}
              src='./assets/activity-4.png' alt=''
            />
        )}
          caption={t.formatMessage({ id: 'play.activity4' })}
        />
      </div>
      <div className={styles.activityCarousel}>
        <ActivityCarousel />
      </div>
    </div>
  )
}

export default Play
